<ion-content class="ion-padding">
  <div class="force-update-container">
    <ion-icon [name]="icon()"></ion-icon>
    <h5>{{ title() }}</h5>
    <p class="subtitle" data-testid="force-update-message">
      {{ message() || 'Hay una nueva versión de la app. Actualízala desde la tienda para seguir usándola.' }}
    </p>
    <ion-button expand="block" shape="round" color="primary" data-testid="force-update-button" (click)="update()">
      {{ buttonLabel() }}
    </ion-button>
  </div>
</ion-content>
